import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dx-card content"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  key: 0,
  class: "title"
};
const _hoisted_4 = {
  class: "description"
};
const _hoisted_5 = {
  key: 0,
  class: "registration-block"
};
const _hoisted_6 = {
  class: "registration-title__second"
};
const _hoisted_7 = {
  class: "registration-types"
};
import DxScrollView from "devextreme-vue/scroll-view";

//  реализация смены title и description

export default {
  __name: 'single-card',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      t
    } = useI18n();
    const title = ref(route.meta.title ? t("Auth." + route.meta.title) : "");
    const description = ref("");

    // обычный watch не отслеживает в  роутах meta данные, нужен именно watchEffect
    watchEffect(() => {
      title.value = t("Auth." + route.meta.title);
      description.value = route.meta.description;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(DxScrollView), {
        height: "100%",
        width: "100%",
        class: "with-footer single-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(route).meta.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(title)), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(description)), 1)]), _unref(route).path.includes('courier') ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("Registration.Courier")), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => !_unref(route).meta.disabledTypes && _unref(router).push('/registration/courier/walk/send-sms')),
          class: _normalizeClass(["registration-type", {
            active: _unref(route).meta.type.includes('walk')
          }])
        }, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("Registration.CourierWalk")), 1)], 2), _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => !_unref(route).meta.disabledTypes && _unref(router).push('/registration/courier/moto/send-sms')),
          class: _normalizeClass(["registration-type", {
            active: _unref(route).meta.type.includes('moto')
          }])
        }, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("Registration.CourierMoto")), 1)], 2)])])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
          _: 3
        }))])]),
        _: 3
      });
    };
  }
};